import SvgIcon from '@mui/material/SvgIcon';
import * as React from 'react';
const SvgFileMusic = (props)=>/*#__PURE__*/ React.createElement(SvgIcon, {
        ...props,
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "m17.416 6.918-2.333-2.332A2 2 0 0 0 13.67 4H8a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8c1.1 0 2-.9 2-2V8.331c0-.528-.21-1.037-.584-1.413M16.5 18a.5.5 0 0 1-.5.5H8a.5.5 0 0 1-.5-.5V6.004a.5.5 0 0 1 .5-.5h5V8a1 1 0 0 0 1 1h2.472v9zm-6-6.022v3.585a2.2 2.2 0 0 0-.5-.063c-.828 0-1.5.45-1.5 1s.672 1 1.5 1 1.5-.45 1.5-1v-3.153l3-1.172v2.387a2.2 2.2 0 0 0-.5-.062c-.828 0-1.5.45-1.5 1s.672 1 1.5 1 1.5-.45 1.5-1v-5a.495.495 0 0 0-.647-.475l-4 1.477a.495.495 0 0 0-.353.476"
    }));
export default SvgFileMusic;
